export default __webpack_public_path__ + "static/media/suv3.9b8755fd.webp";